var ConversationId = require('conversation/conversation-id');

module.exports = {
    cidFromHeaders : function(headers) {
        if (!headers || headers.length === 0) {
            throw new Error("Empty headers, expected at least 1");
        }

        return ConversationId.fromString(headers[headers.length - 1]);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/v4-stack/headers-tunnel.js
// module id = 1108
// module chunks = 0